import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets the window scroll to the top on every route change so a newly opened
 * page starts at its hero, not wherever the previous page was scrolled to.
 *
 * The global `html { scroll-behavior: smooth }` rule (used by the navbar's
 * in-page anchor links) would otherwise animate this reset — visibly scrolling
 * from the bottom up. `behavior: "instant"` overrides that rule for this one
 * call; the inline `scroll-behavior: auto` (held across a frame) is a fallback
 * for browsers that don't honor "instant". Hash links (e.g. "/#pricing") are
 * left alone so section anchors still smooth-scroll.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    if (hash) return;

    const html = document.documentElement;
    const previous = html.style.scrollBehavior;
    html.style.scrollBehavior = "auto";

    window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });

    requestAnimationFrame(() => {
      html.style.scrollBehavior = previous;
    });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
